import { Form, Input, Button, Card, Spin, Select } from "antd";
import React, { Component } from "react";
import { showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./TicketCategory.css";
import "./CreateTicketCategory.css";
import { Constants } from "../../data/constants";
import { TicketCategoryService } from "../../services/ticketCategory/TicketCategoryService";
import { Translation } from "react-i18next";
import i18next from "i18next";

class CreateTicketCategoryForm extends Component {
  ticketCategoryService = new TicketCategoryService();

  constructor(props) {
    super(props);

    this.props.context.setCurrentComponent("createTicketCategory");
    this.constants = new Constants();
    this.state = {
      confirmDirty: false,
      ticketCategory: {},
      isFetching: false,
      formLayout: "inline",
      editMode: false,
      recordData: this.props.recordData ? this.props.recordData.id : "",
      allTicketCategoryStatus: [],
    };
  }

  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      if (this.props.editMode && this.props.recordData) {
        let data = await this.ticketCategoryService.getTicketCategoryById(
          this.props.context.session_id,
          this.state.recordData
        );
        this.setState({
          ticketCategory: data.ivrCustomEntityObject,
        });
      }

      // let allTicketCategoryStatus =
      //   await this.ticketCategoryService.getAllTicketCategoryStatusService(
      //     this.props.context.session_id
      //   );

      this.setState({
        //allTicketCategoryStatus: allTicketCategoryStatus.ivrList,
        isFetching: false,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async createTicketCategoryApi(values) {
    let history = this.props.history;
    try {
      let data = await this.ticketCategoryService.createTicketCategory(
        this.props.context.session_id,
        values
      );
      showSuccessToast(i18next.t(data.statusMsg));
      this.setState({ loading: false });
      this.props.form.resetFields();
      history.push("/home/ticketCategories/");
    } catch (e) {
      this.setState({ loading: false });
      handleError(e);
    }
  }

  async editTicketCategoryApi(values) {
    values["ticketCategoryId"] = this.props.recordData.id;
    try {
      let data = await this.ticketCategoryService.editTicketCategory(
        this.props.context.session_id,
        values
      );
      let history = this.props.history;
      showSuccessToast(i18next.t(data.statusMsg));
      this.setState({ loading: false });
      this.props.form.resetFields();
      history.push("/home/ticketCategories/");
    } catch (e) {
      this.setState({ loading: false });
      handleError(e);
    }
  }

  handleConfirm = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });

          if (this.props.editMode) {
            this.editTicketCategoryApi(values);
          } else {
            this.createTicketCategoryApi(values);
          }
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    let { isFetching, allTicketCategoryStatus } = this.state;
    const { Option } = Select;
    const ticketCategoryStatusOptions = allTicketCategoryStatus.map((opt) => (
      <Option key={opt.name} value={opt.code}>
        {opt.name}
      </Option>
    ));
    return (
      <Translation>
        {(t) => (
          <Page
            title={
              this.props.editMode
                ? t("Edit Ticket Category ")
                : t("Create Ticket Category")
            }
            hasBackArrow={true}
            ticketCategoryBack={this.props.recordData ? true : false}
            back={() => {
              this.props.back();
            }}
          >
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    <Form.Item label={t("Name")} {...formItemLayout}>
                      {getFieldDecorator("ticketCategoryName", {
                        initialValue: this.state.ticketCategory.name,
                        rules: [
                          {
                            type: "string",
                            message: t("The input is not valid "),
                          },
                          {
                            required: true,
                            message: t("Please enter  ticket category name"),
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>

                    {/* <Form.Item label="Code" {...formItemLayout}>
                  {getFieldDecorator("ticketCategoryCode", {
                    initialValue: this.state.ticketCategory.code,
                    rules: [
                      {
                        type: "string",
                        message: "The input is not valid ",
                      },
                      {
                        required: true,
                        message: "Please enter  ticket category code",
                      },
                    ],
                  })(<Input />)}
                </Form.Item> */}
                    {/* <Form.Item label="Status" {...formItemLayout}>
                  {getFieldDecorator("ticketCategoryStatus", {
                    initialValue: this.state.ticketCategory.status
                      ? this.state.ticketCategory.status
                      : "INIT",

                    rules: [
                      {
                        required: true,
                        message: "Please select ticket category status",
                      },
                    ],
                  })(
                    <Select placeholder="Select ">
                      {ticketCategoryStatusOptions}
                    </Select>
                  )}
                </Form.Item> */}
                    <Form.Item
                      wrapperCol={{
                        xs: { span: 24, offset: 0 },
                        sm: { span: 16, offset: 8 },
                      }}
                    >
                      <Button
                        className="button-submit"
                        type="primary"
                        onClick={this.handleConfirm}
                        size={"small"}
                        loading={this.state.loading}
                      >
                        {t("Submit")}
                      </Button>
                    </Form.Item>
                  </Form>
                </Card>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(CreateTicketCategoryForm))
);
